import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from '../../../../../services/storage.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../interfaces/app-state.interface';
import { TrackingActions } from '../../../../../state-management/tracking/tracking.action';
import { ChatOnboardingService } from '../../../services/chat-onboarding.service';

@Component({
  selector: 'welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent {
  @Input() checklistStatus: BehaviorSubject<boolean>;

  constructor(
    private store: Store<AppState>,
    private chatOnboardingService: ChatOnboardingService,
  ) { }

  ngOnInit() {
  }

  public start() {
    this.sendTracking('Element Clicked', {
        'Product Area Origin': window.location.pathname,
        'Element': 'Botão iniciar onboarding',
        'Group': 'Onboarding Trader',
        'Scenario': 'Início onboarding',
        'Time Responsável': 'Brooklyn Dumbo',
    })

    StorageService.setCookie('chat-onboarding-welcome', 'true', this.chatOnboardingService.expirationCookie('YEARLY'));
    this.checklistStatus.next(true);
  }

  public sendTracking(event: string, breakdowns: any) {
    this.store.dispatch({
        type: TrackingActions.trackEvents,
        payload: { type: event, events: breakdowns },
    });
}

}
